import { render, staticRenderFns } from "./proposalHistoryCoyp.vue?vue&type=template&id=86497f0a&scoped=true"
import script from "./proposalHistoryCoyp.vue?vue&type=script&lang=js"
export * from "./proposalHistoryCoyp.vue?vue&type=script&lang=js"
import style0 from "./proposalHistoryCoyp.vue?vue&type=style&index=0&id=86497f0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86497f0a",
  null
  
)

export default component.exports